import React from "react";

export const AED: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="77"
    height="75"
    viewBox="0 0 77 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M67.9773 9.38669C66.2669 7.48081 64.2361 5.96893 62.001 4.93742C59.7658 3.90592 57.37 3.375 54.9506 3.375C52.5311 3.375 50.1354 3.90592 47.9002 4.93742C45.665 5.96893 43.6342 7.48081 41.9238 9.38669L38.3741 13.3402L34.8244 9.38669C31.3695 5.53875 26.6836 3.37699 21.7976 3.37699C16.9116 3.37699 12.2258 5.53875 8.77086 9.38669C5.31595 13.2346 3.375 18.4536 3.375 23.8954C3.375 29.3372 5.31595 34.5561 8.77086 38.4041L12.3206 42.3576L38.3741 71.375L64.4276 42.3576L67.9773 38.4041C69.6886 36.4991 71.046 34.2373 71.9722 31.7478C72.8983 29.2584 73.375 26.5901 73.375 23.8954C73.375 21.2007 72.8983 18.5324 71.9722 16.043C71.046 13.5535 69.6886 11.2917 67.9773 9.38669Z"
      fill="#F87171"
      stroke="#F87171"
      strokeWidth="6.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.241 17.7415H33.6234L28.1807 35.9271H37.2518L34.5305 45.0199H41.7874L36.3447 61.1848L52.2193 37.4425H43.1481L47.2301 27.3394H38.6125L42.241 17.7415Z"
      fill="#FFED50"
      stroke="#FFED50"
      strokeWidth="0.914219"
    />
  </svg>
);
